"use client";

import { useState, useEffect } from "react";
import { DesktopMenuToggle } from "./DesktopMenuToggle";
import { MobileMenuToggle } from "./MobileMenuToggle";
import { MenuPanel } from "./MenuPanel";
import { AfricaTownLogo } from "@/components/AfricaTownLogo";

export default function NavigationMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const handleToggle = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="w-full h-full">
      <div className="nav-bar">
        <div className="logo">
          <a href="/" aria-label="AfricaTown home">
            <AfricaTownLogo
              className="h-12 sm:h-16 md:h-20 lg:h-24 w-auto text-background"
              buildingsColor="var(--color-primary)"
            />
          </a>
        </div>
        <div className="hidden md:block">
          <DesktopMenuToggle
            isOpen={isOpen}
            onToggle={handleToggle}
            disabled={isAnimating}
          />
        </div>
        <div className="md:hidden">
          <MobileMenuToggle
            isOpen={isOpen}
            onToggle={handleToggle}
            disabled={isAnimating}
          />
        </div>
      </div>
      <MenuPanel
        isOpen={isOpen}
        onAnimationComplete={() => setIsAnimating(false)}
      />
    </div>
  );
}
